import { Component, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error("[ruteando] render error", error);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, fontFamily: "Inter, sans-serif", color: "#222" }}>
          <h1 style={{ fontSize: 18, margin: "0 0 8px" }}>Algo se rompió en la página.</h1>
          <pre style={{ fontSize: 12, opacity: 0.7 }}>{this.state.error.message}</pre>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            style={{ marginTop: 12, padding: "8px 12px", cursor: "pointer" }}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
